import { IPoi } from "~/interfaces";
import Content from "./content";
import { createKeyValTags } from "../ui/keyvaltags";

export default class KeyValueTags extends Content {
	_build() {
		const detailData: IPoi = this._options.data;
		const items: IPoi["extend"]["poi"]["keyval_tags"] = this._data || [];

		this._dom.container.classList.add("content-keyvaluetags");

		if ("review" in detailData) {
			this._dom.container.classList.add("detail-has-review");
		}

		if (items.length) {
			const updatedItems = items.map(item => ({
				...item,
				text: `${item.text[0].toLocaleUpperCase()}${item.text.slice(1)}`,
			}));

			const container = createKeyValTags(updatedItems);

			this._dom.container.append(container);
		} else {
			this._dom.container.classList.add("empty");
		}
	}
}
